import React from "react";
import { User } from "../../userTypes";

type Props = {
  user: User;
};

export default class VerificationSummaryTable extends React.Component<Props> {
  render() {
    const { user } = this.props;

    return (
      <section className="page">
        <table
          style={{
            fontSize: "14px",
            paddingTop: "10px",
            width: "100%",
          }}
          className="BOTable"
          cellPadding={0}
          cellSpacing={0}
        >
          <thead>
            <tr>
              <td colSpan={6}>
                <h3
                  style={{
                    borderBottom: "1px solid rgb(204, 204, 204)",
                    fontWeight: 400,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <p style={{ flex: 1 }}>Verification summary</p>
                </h3>
              </td>
            </tr>

            {user.risk_assessment != null ||
            user.identity_verification != null ||
            user.automatic_verification_request != null ||
            user.manual_verification_request != null ? (
              <tr>
                <th style={{ textAlign: "left" }}>
                  <b style={{ color: "#555" }}>Verification type</b>
                </th>
                <th style={{ textAlign: "left" }}>
                  <b style={{ color: "#555" }}>Status</b>
                </th>
                <th style={{ textAlign: "left" }}>
                  <b style={{ color: "#555" }}>Created at</b>
                </th>
                <th style={{ textAlign: "left" }}>
                  <b style={{ color: "#555" }}>Updated at</b>
                </th>
              </tr>
            ) : (
              <tr />
            )}
          </thead>
          {user.identity_verification == null ? (
            <tbody>
              <tr
                style={{
                  background: "#F9F9F9",
                }}
              >
                <td> iidentifii identity verification </td>
                <td>
                  {" "}
                  There are no identity verifications associated with this user.{" "}
                </td>
                <td> </td>
                <td> </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              <tr
                style={{
                  background: "#F9F9F9",
                }}
              >
                <td> iidentifii identity verification </td>
                <td> {user.identity_verification.status} </td>
                <td> {user.identity_verification.created_at} </td>
                <td> {user.identity_verification.updated_at} </td>
              </tr>
            </tbody>
          )}

          {user.risk_assessment == null ? (
            <tbody>
              <tr
                style={{
                  background: "#F9F9F9",
                }}
              >
                <td> RelyComply risk assessment </td>
                <td>
                  {" "}
                  There are no RelyComply risk assessments associated with this
                  user.{" "}
                </td>
                <td> </td>
                <td> </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              <tr
                style={{
                  background: "#F9F9F9",
                }}
              >
                <td> RelyComply risk assessment </td>
                <td> {user.risk_assessment.risk_status} </td>
                <td> {user.risk_assessment.created_at} </td>
                <td> {user.risk_assessment.updated_at} </td>
              </tr>
            </tbody>
          )}
          {user.automatic_verification_request == null ? (
            <tbody>
              <tr
                style={{
                  background: "#F9F9F9",
                }}
              >
                <td> Automatic verification </td>
                <td>
                  {" "}
                  There are no automatic verification requests associated with
                  this user.{" "}
                </td>
                <td> </td>
                <td> </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              <tr
                style={{
                  background: "#F9F9F9",
                }}
              >
                <td> Automatic verification </td>
                <td> {user.automatic_verification_request.status} </td>
                <td> {user.automatic_verification_request.created_at} </td>
                <td> {user.automatic_verification_request.updated_at} </td>
              </tr>
            </tbody>
          )}
          {user.manual_verification_request == null ? (
            <tbody>
              <tr
                style={{
                  background: "#F9F9F9",
                }}
              >
                <td> Manual verification </td>
                <td>
                  {" "}
                  There are no manual verification requests associated with this
                  user.{" "}
                </td>
                <td> </td>
                <td> </td>
              </tr>
            </tbody>
          ) : (
            <tbody>
              <tr
                style={{
                  background: "#F9F9F9",
                }}
              >
                <td> Manual verification </td>
                <td> {user.manual_verification_request.status} </td>
                <td> {user.manual_verification_request.created_at} </td>
                <td> {user.manual_verification_request.updated_at} </td>
              </tr>
            </tbody>
          )}
        </table>
      </section>
    );
  }
}
